/**
 *
 * Asynchronously loads the component for BulkImport
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
